import { checkIfFileOrFolderExist } from "../../../services/GraphService";
import { IItemCheck } from "./IItemCheck";

export class NormalDriveItemCheck implements IItemCheck {
    constructor(private driveId: string) { }
    doesItemExist = async (itemId: string) => {
        return await checkIfFileOrFolderExist({
            id: itemId,
            driveId: this.driveId
        });
    };
}
